import Div from 'src/components/typography/div'
import { Card, CardTitle } from 'src/components/ui/card'
import { useProjectStore } from 'src/store/projectStore'
import CustomTable from './CustomTable'
import SearchComponent from './SearchComponent'
import { useCallback, useState } from 'react'

function ProjectsTable({ projects }: any) {
    const [filteredProjects,setFilteredProjects] = useState(projects);

    const updateSearchFilter = useCallback((value: string) => {
        let cashUnlockedProjects = [...projects];
        cashUnlockedProjects = cashUnlockedProjects.filter((project:any)=>project?.projectTitle.includes(value));
        setFilteredProjects(cashUnlockedProjects);
    },[])

    return (
        <Div className=' '>
            <Card className='  border-none shadow-none p-6  w-full'>
                <div className='flex justify-between'>
                    <CardTitle className='text-lg font-normal'>Projects</CardTitle>
                    <SearchComponent updateSearch={updateSearchFilter} />
                </div>
                <CustomTable projects={filteredProjects} />
            </Card>
        </Div>
    )
}

export default ProjectsTable